/**
 * client/src/lib/use-security-features.ts
 *
 * Client read for the platform-wide security-model kill switches
 * (`security_memories`, `security_guardians` — ledger #62). Default-ON /
 * opt-OUT (useFeatureFlagWithDefault, the onboarding_sensory_vault posture):
 * a missing row or unloaded flags query keeps every surface visible; only an
 * explicit operator-created isEnabled=false row hides an element.
 *
 * Display gating ONLY — the server route gates (security-feature-gates.ts,
 * assertCeremonyEnabled) are always authoritative. Hiding here is what keeps
 * a disabled element from rendering dead controls (buttons whose only
 * possible outcome is a 404).
 */

import { FLAG_KEYS } from "@shared/feature-flags";
import { useFeatureFlagWithDefault } from "./use-feature-flag";

export interface SecurityFeatures {
  /** The memories / cognitive-bank element (bespoke seeding, memory panels, rung-3 step). */
  memoriesEnabled: boolean;
  /** The guardians element (circle, guardian recovery, guardian step-up, invitations). */
  guardiansEnabled: boolean;
}

/** Whether each security-model element is enabled platform-wide (default ON). */
export function useSecurityFeatures(): SecurityFeatures {
  return {
    memoriesEnabled: useFeatureFlagWithDefault(FLAG_KEYS.SECURITY_MEMORIES, true),
    guardiansEnabled: useFeatureFlagWithDefault(FLAG_KEYS.SECURITY_GUARDIANS, true),
  };
}
